import React, { setGlobal, useState } from "reactn";
import PropTypes from "prop-types";

// Hooks
import appHook from "../../../hooks/appHook";

// images
import Icon from "../icons/ReturnIcons";

import FormGroup from "../form/form_group/FormGroup";
import InputGroup from "../form/input_group/InputGroup";
import Input from "../form/input/Input";
import Error from "../error/Error";
import Label from "../form/label/Label";
import AddressLookUpList from "./AddressLookUpList";
import TextareaStyled from "./Textarea.styled";

//helper functions
import { autoCompleteAddress, findAddress } from "../../../services/Api";

const AddressLookUp = ({ addressId, showText, innerTitle, handleBlur, handleKeyup, manualForm, values, errors }) => {

    const [textarea, setTextarea] = useState(showText);

    /**
     * `manualEntry` boolean, If the user clicks to manually enter
     */
    const [manualEntry, setManualEntry] = useState(false);

    /**
     * `addressListMessage` A message to be displayed on above the results
     */
    const [addressListMessage, setaddressListMessage] = useState("");

    /**
    * `reformattedAddress` This is for display in the text box
    */
    const [reformattedAddress, setreformattedAddress] = useState([]);

    /**
     * `dataReturned` boolean, if data has been return from address API
     */
    const [dataReturned, setDataReturned] = useState(false);

    /**
     * `addresses` array of the addresses returned from the API
     */
    const [addresses, setAddresses] = useState([]);

    /**
     * `addressLookUp` queries the auto address API.
     *  https://www.autoaddress.ie/support/developer-centre/faqs/general
     *  @param {string} address - this is passed on to the API to return an address
     */

    const addressLookUp = add => {
        // temporary address
        let tempAddresses = {
            displayName: add + "- Address Search"
        };
        // set the address to the values passed in
        values[addressId] = add;
        setGlobal({
            values: values
        });

        if (!dataReturned) {
            setAddresses([tempAddresses]);
        }

        const addressCallback = response => {
            // add the options to the addresses array
            if (response.data.options.length > 0) {
                setAddresses(response.data.options);
                setDataReturned(true);
            } else {
                setDataReturned(false);
            }
        }

        // get request to the auto address API only after 6 characters. Exists in services/API file
        if (add.length > 5) {
            autoCompleteAddress(add, addressCallback);
        }

    };

    // used to manually enter information.
    const manuallyEnter = () => {
        // set address array to empty array
        cancelLookUp();

        //show the manual entry form
        setManualEntry(true);
        if (addressId === "newaddress") {
            setGlobal({
                values: { ...values, manualEntryNew: true }
            });
        } else {
            setGlobal({
                values: { ...values, manualEntry: true }
            });
        }

    };

    // used to close the address pop up.
    const cancelLookUp = () => {
        //reset message
        setaddressListMessage("");
        // set address array to empty array
        setAddresses([]);
    };

    // findaddress callback
    const findAddressCallback = response => {
        if (response.data.options.length > 0) {
            setaddressListMessage(`We have found a number of addresses like this. Please select an option below:`);
            setAddresses([]);
            setAddresses(response.data.options);
        } else {
            if (response.data.reformattedAddress) {
                // set reformatted address
                setreformattedAddress(response.data.postalAddress);

                setGlobal({
                    values: { ...values, reformattedAddress: response.data.postalAddress }
                });

                // show textarea
                setTextarea(true);

                // hide the returned results
                cancelLookUp();
            } else {
                setaddressListMessage("We couldn't find that address. Try searching again or enter the address manually.");
            }
        }
    }

    const handleSelect = e => {
        // get the data attr that contains the address and the url
        const selectedAddress = e.target.getAttribute("data-address");
        const selectedUrl = e.target.getAttribute("data-link");

        // set the address to the address the user has selected
        values[addressId] = selectedAddress;
        setGlobal({
            values: values
        });

        // Call find address API
        findAddress(selectedAddress, findAddressCallback, selectedUrl);
    };

    // import hooks from appHook
    const { handleFocus, focus } = appHook();

    const editAddress = () => {
        // hide textarea
        setTextarea(false);
    };

    // This sets global values autoaddress1, autoaddress2 etc.
    const setAutoAddressValues = addressArray => {
        addressArray.map((item, index) => {
            let addressProperty = `auto${addressId + (index + 1)}`;
            values[addressProperty] = item;
            return false;
        });
    }


    const refactorAddress = () => {
        // reformatting the address
        const addressArray = reformattedAddress;

        // set global address values
        setAutoAddressValues(addressArray);

        return addressArray.map(item => {
            return <span key={item}>{item}</span>;
        });
    };

    return (
        <>
            <FormGroup focused={focus === addressId ? true : !!(false || values[addressId])}>
                <InputGroup>
                    {textarea ? (
                        <TextareaStyled>
                            {innerTitle &&
                                <>
                                    <p><strong>Your address</strong></p>
                                </>
                            }
                            <p>{refactorAddress()}</p>
                            <button type="button" onClick={editAddress}>
                                <Icon src="editIcon" />
                                Edit
                            </button>
                        </TextareaStyled>
                    ) : (!manualEntry &&
                        <>
                            <Label htmlFor={addressId} text="Start typing your address or Eircode" />
                            <Input
                                id={addressId}
                                type="text"
                                name={addressId}
                                change={e => addressLookUp(e.target.value)}
                                keyup={handleKeyup}
                                focus={handleFocus}
                                blur={handleBlur}
                                value={values[addressId]}
                                autoComplete="off"
                                required
                            />
                            {errors[addressId] && <Error error={errors[addressId]} />}

                        </>
                        )}
                </InputGroup>
                {addresses.length !== 0 && <AddressLookUpList handleSelect={handleSelect} addresses={addresses} manuallyEnter={manuallyEnter} handleCancel={cancelLookUp} message={addressListMessage} />}
            </FormGroup>
            {manualEntry &&
                <>{manualForm}</>
            }
        </>
    );
};

export default AddressLookUp;

// props validation
AddressLookUp.propTypes = {
    addressId: PropTypes.string,
    showText: PropTypes.bool,
    innerTitle: PropTypes.bool,
    handleBlur: PropTypes.func,
    handleChange: PropTypes.func,
    handleKeyup: PropTypes.func,
    manualForm: PropTypes.any,
    value: PropTypes.object,
    errors: PropTypes.object
};